import React, { useState } from 'react';
import styled, { keyframes } from 'styled-components';

import {
	Typography,
	FormControl,
	FormControlLabel,
	RadioGroup,
	Radio,
} from '@material-ui/core';

import NetzentgelteIcon from '../../assets/icon-kosten-senken-wei.svg';
import EigenverbrauchIcon from '../../assets/icon-umwelt-co-2-einsparung-wei.svg';

const bounceAnimation = keyframes`
	0% { transform: translateX(0); }
	30% { transform: translateX(20px); }
	50% { transform: translateX(0); }
	100% { transform: translateX(0); }
`;

const Root = styled.div`
	position: absolute;
	background-color: ${(props) =>
		props.theme.palette.blocks.dashboardSwitch.backgroundColor};
	top: 400px;
	left: -200px;
	padding: 20px;
	border-radius: 0 80px 80px 0;
	z-index: 1099;
	animation-name: ${bounceAnimation};
	animation-duration: 2s;
	animation-iteration-count: 2;
	box-shadow: rgb(0 0 0 / 30%) 0px 0px 10px 0;
	transition: all 0.3s ease-in-out;

	&:hover,
	:active {
		left: 0px;
		animation: stop;
	}

	h6 {
		font-size: 16px;
		font-weight: bold;
		text-transform: uppercase;
		margin-bottom: 20px;
	}

	img {
		margin-left: 40px;
	}

	.MuiFormGroup-root {
		margin-left: -9px;
	}
`;

const DashboardSwitch = ({ activeSwitchState }) => {
	const netzentgelte = 'Netzentgelte';
	const eigenverbrauch = 'Eigenverbrauch';
	const [value, setValue] = useState(netzentgelte);

	const handleChange = (event) => {
		setValue(event.target.value);
		activeSwitchState();
	};

	return (
		<Root>
			<Typography variant="h6">Optimerungsziel</Typography>
			<FormControl component="fieldset">
				<RadioGroup name="optimierungsziel" value={value} onChange={handleChange}>
					<FormControlLabel
						value={netzentgelte}
						control={<Radio />}
						label={netzentgelte}
					/>
					<FormControlLabel
						value={eigenverbrauch}
						control={<Radio />}
						label={eigenverbrauch}
					/>
				</RadioGroup>
			</FormControl>
			<img
				src={value === netzentgelte ? NetzentgelteIcon : EigenverbrauchIcon}
				alt="Optimierungsziel"
			/>
		</Root>
	);
};

export default DashboardSwitch;
